function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "path-1-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M123.506 13L116 0L108.494 13H10C6.68629 13 4 15.6863 4 19V92C4 95.3137 6.6863 98 10 98H431C434.314 98 437 95.3137 437 92V19C437 15.6863 434.314 13 431 13H123.506Z"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M123.506 13L116 0L108.494 13H10C6.68629 13 4 15.6863 4 19V92C4 95.3137 6.6863 98 10 98H431C434.314 98 437 95.3137 437 92V19C437 15.6863 434.314 13 431 13H123.506Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116 0L116.866 -0.5L116 -2L115.134 -0.5L116 0ZM123.506 13L122.64 13.5L122.928 14H123.506V13ZM108.494 13V14H109.072L109.36 13.5L108.494 13ZM115.134 0.5L122.64 13.5L124.372 12.5L116.866 -0.5L115.134 0.5ZM109.36 13.5L116.866 0.5L115.134 -0.5L107.628 12.5L109.36 13.5ZM10 14H108.494V12H10V14ZM5 19C5 16.2386 7.23858 14 10 14V12C6.13401 12 3 15.134 3 19H5ZM5 92V19H3V92H5ZM10 97C7.23858 97 5 94.7614 5 92H3C3 95.866 6.13401 99 10 99V97ZM431 97H10V99H431V97ZM436 92C436 94.7614 433.761 97 431 97V99C434.866 99 438 95.866 438 92H436ZM436 19V92H438V19H436ZM431 14C433.761 14 436 16.2386 436 19H438C438 15.134 434.866 12 431 12V14ZM123.506 14H431V12H123.506V14Z",
  fill: "#E8E8E8",
  mask: "url(#path-1-inside-1)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 441,
  height: 106,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgImgTooltip = function SvgImgTooltip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 441,
    height: 106,
    viewBox: "0 0 441 106",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImgTooltip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/img_tooltip.8d084d97.svg";
export { ForwardRef as ReactComponent };